import { render } from "./ProfesionalModificacionDetalle.vue?vue&type=template&id=386838b2&ts=true"
import script from "./ProfesionalModificacionDetalle.vue?vue&type=script&lang=ts"
export * from "./ProfesionalModificacionDetalle.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/front-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__